//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Ben Layton
 * Original Team: Fore oh Four!
 */
import { VTextField, VSelect } from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';
import phoneFormats from './phoneFormats.js';

export default {
  name: 'NsPhoneNumber',
  components: {
    NsIcon,
    VTextField,
    VSelect,
  },
  props: {
    /**
     * Countries as a key:value object
     *  -- example: AR:"Argentina"
     * {
     *   AR: "Argentina",
     *   AT: "Austria"
     * }
     */
    countryNames: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Field Label
     */
    label: {
      type: String,
      default: 'Mobile Phone',
    },
    /**
     * Required message
     */
    errorMessage: {
      type: String,
      default: 'This field is required',
    },
    /**
     * Invalid Message
     */
    invalidMessage: {
      type: String,
      default: 'Invalid Phone Number Format',
    },
    /**
     * Hide details
     */
    hideDetails: {
      type: Boolean,
      default: false,
    },
    /**
     * Disable the country prefix
     */
    disablePrefix: {
      type: Boolean,
      default: false,
    },
    /**
     * Default country code
     */
    country: {
      type: String,
      default: 'US',
    },
    number: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      error: false,
      mobilePhoneNumber: { country: this.country, number: this.number },
      phonePrefix: phoneFormats.US.countryPhoneCode,
      minLength: phoneFormats.US.minLength,
      maxLength: phoneFormats.US.minLength,
      phoneMask: phoneFormats.US.mask,
      form: {},
      rules: [
        (v) => (v || '').length > 0 || this.errorMessage,
        (v) => (v || '').length >= this.minLength || this.invalidMessage,
        (v) => !v || /^[0-9 ()+-]+$/.test(v.trim()) || this.invalidMessage,
        (v) =>
          (v || '').length <= (this.maxLength ? this.maxLength : 100) ||
          this.invalidMessage,
      ],
      placeholder: phoneFormats.US.placeholder,
      phoneValid: null,
      menuProps: { minWidth: 350, offsetY: true, flat: true },
      focused: false,
    };
  },
  computed: {
    countryList() {
      let countryList;
      // if countryNames is given as a prop
      let countryCodes = Object.keys(this.countryNames);
      if (countryCodes.length > 0) {
        countryList = countryCodes.reduce((acc, code) => {
          if (phoneFormats[code]) {
            acc.push(
              this.createCountryItem(
                this.countryNames[code],
                phoneFormats[code].countryPhoneCode,
                code
              )
            );
          }

          return acc;
        }, []);
      } else {
        // use default phoneFormats
        countryCodes = Object.keys(phoneFormats);
        countryList = countryCodes.map((code) =>
          this.createCountryItem(
            phoneFormats[code].countryName,
            phoneFormats[code].countryPhoneCode,
            code
          )
        );
      }

      countryList.sort((v1, v2) => v1.text.localeCompare(v2.text));

      return countryList;
    },
    isNumber() {
      let type = '';
      if (this.country === 'JP') {
        type = 'number';
      }
      return type;
    },
  },
  watch: {
    country() {
      this.changedMobileCountry(this.country);
    },
    number(newNumber) {
      if (newNumber !== this.mobilePhoneNumber.number) {
        this.mobilePhoneNumber.number = newNumber;
        this.receiveInput();
      }
    },
  },
  created() {
    this.changedMobileCountry(this.country);
  },
  methods: {
    createCountryItem(countryName, prefix, value) {
      return {
        text: `${countryName} (${prefix})`,
        value,
      };
    },
    onlyNumbers() {
      this.mobilePhoneNumber.number = this.mobilePhoneNumber.number.replace(
        /[^\d]/,
        ''
      );
    },
    closeDialog() {
      this.$emit('closeDialog');
      this.dialogError = null;
    },
    changedMobileCountry(value) {
      let countryFormat = phoneFormats[value];
      this.phonePrefix = countryFormat.countryPhoneCode;
      this.phoneMask = countryFormat.mask;
      this.placeholder = countryFormat.placeholder;
      this.minLength = countryFormat.minLength;
      this.maxLength = countryFormat.maxLength;
      this.mobilePhoneNumber.country = value;
    },
    receiveBlur() {
      this.focused = false;
      this.receiveError();
      this.$emit('input', this.mobilePhoneNumber);
    },
    receiveInput() {
      this.receiveError();
      this.$emit('input', this.mobilePhoneNumber);
    },
    receiveError() {
      const valid = this.rules.every(
        (fn) => fn(this.mobilePhoneNumber.number) === true
      );
      this.$emit('update:error', (this.error = !valid));
    },
    updatePhone() {
      const self = this;
      const updatedMobilePhoneNumber = {
        phoneNumbers: {
          mobile: {
            country: self.mobilePhoneNumber.country,
            value: self.mobilePhoneNumber.number,
          },
        },
      };
      this.$emit('phoneNumberUpdated', updatedMobilePhoneNumber);
    },
  },
};
